<div *ngIf="!difference; else diffInfo">
    <ng-container [ngTemplateOutlet]="content.templateRef" [ngTemplateOutletContext]="context"></ng-container>
</div>
<ng-template #diffInfo>
    <p class="detail-diff">
        <span>{{ 'INTERFACE|różne wartości:' | translate}}</span>
        <ng-container *ngFor="let document of documentList">
            <div><ng-container [ngTemplateOutlet]="content.templateRef" [ngTemplateOutletContext]="{value: transform(document[property])}"></ng-container></div>
        </ng-container>
    </p>
</ng-template>